<!-- @veltra/icons generated sha256:5329692b6292a731 gen:8 source:src/svg/normal/process.svg -->
<script setup lang="ts">
defineOptions({ name: 'Process' })
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    viewBox="0 0 24 24"
  >
    <path
      d="M12 20v2M12 2v2M17 20v2M17 2v2M2 12h2M2 17h2M2 7h2M20 12h2M20 17h2M20 7h2M7 20v2M7 2v2"
    />
    <rect width="16" height="16" x="4" y="4" rx="2" />
    <rect width="8" height="8" x="8" y="8" rx="1" />
  </svg>
</template>
